<template>
  <div class="content if-profile report-tab">
    <div class="md-layout finanical-insights-body">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0">
       <CRHeader :headerData="this.headerData"/>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <div class="navbar md-toolbar md-transparent md-elevation-4 p-0">
          <div class="md-toolbar-row p-0">
            <nav-tabs-card>
              <template slot="content">
                <!-- <div class="md-toolbar-row map-box-title">
                    <div class="md-layout">
                      <md-card-header class="md-card-header-icon">
                        <h1 class="md-title text-left profile-title">
                          Terms
                        </h1>
                      </md-card-header>
                    </div>
                </div>-->
                <div class="md-layout">
                  <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                    <md-card class="if_card">
                      <md-card-header>Terms</md-card-header>
                      <md-card-content>
                        <div class="md-layout p-4">
                          <div class="md-layout-item md-medium-size-100 md-size-50">
                            <md-card class="md-card-profile">
                              <md-card-header>
                                <h4 class="title m-0">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                  >Industry Financial Insight Terms</div>
                                </h4>
                              </md-card-header>
                              <md-card-content>
                                <div class="extra_space">
                                  <ul>
                                    <li>
                                      <p>
                                        Industry peer group percentage averages
                                        are applied to the company's
                                        estimatedrevenue.
                                      </p>
                                    </li>
                                    <li>
                                      Gross Margin:
                                      <p>Business Revenue minus Cost of Sales</p>
                                    </li>
                                    <li>
                                      Officer/Owner's Compensation:
                                      <p>
                                        Total wage compensation for services of
                                        company officers
                                      </p>
                                    </li>
                                    <li>
                                      Depreciation:
                                      <p>
                                        Current portion of non-cash
                                        depreciation-amortization-depletion
                                      </p>
                                    </li>
                                    <li>
                                      Operating Expenses:
                                      <p>
                                        Discretionary Expenses (excludes Cost of
                                        Sales and Interest Paid)
                                      </p>
                                    </li>
                                    <li>
                                      After-Tax Net Profit:
                                      <p>Net Profit after payment of income taxes</p>
                                    </li>
                                    <li>
                                      Owner Earnings:
                                      <p>
                                        Officers Compensation+Net
                                        Profit+Depreciation
                                      </p>
                                    </li>
                                    <li>
                                      Net Worth/Assets:
                                      <p>Net Worth as a percent of Total Assets</p>
                                    </li>
                                    <li>
                                      Accounts Receivable: Total Assets:
                                      <p>
                                        Short-term receivables as a percent of
                                        Total Assets
                                      </p>
                                    </li>
                                    <li>
                                      Accounts Payable:TL&amp; NW:
                                      <p>
                                        Short-term receivables as a percent of
                                        Total Liabilities+Net Worth
                                      </p>
                                    </li>
                                    <li>
                                      Days Payable:
                                      <p>
                                        365/(Cost of Sales/Accounts Payable
                                        ratio)
                                      </p>
                                    </li>
                                    <li>
                                      Days Receivable:
                                      <p>365/(Business Revenue/Receivables)</p>
                                    </li>
                                    <li>
                                      Current Ratio:
                                      <p>Current Assets/Current Liabilities</p>
                                    </li>
                                    <li>
                                      Interest Coverage:
                                      <p>
                                        [Earnings before Interest, Taxes Due,
                                        DepreciationAmortization]/Interest
                                        expense
                                      </p>
                                    </li>
                                    <li>
                                      Current Liabilities:
                                      <p>Net Worth: Current Liabilities/Net Worth</p>
                                    </li>
                                    <li>
                                      Total Liabilities: Net Worth:
                                      <p>Total liabilities/Net Worth</p>
                                    </li>
                                    <li>
                                      Modified Z-Score:
                                      <p>
                                        A modified form of the Altman Z-Score
                                        which evaluates default risk
                                      </p>
                                    </li>
                                    <li>
                                      Net Working Capital: Revenue:
                                      <p>
                                        (Current Assets-Current
                                        Liabilities)/Business Revenue
                                      </p>
                                    </li>
                                    <li>
                                      Accounts Payable:Revenue:
                                      <p>Accounts Payable/Business Revenue</p>
                                    </li>
                                    <li>
                                      Loans-Notes Payable:Net Worth:
                                      <p>Loans-Notes Payable/Net Worth</p>
                                    </li>
                                    <!-- <h1 class="md-body-2 text-left">
                                        <b>INDUSTRY FINANCIAL INSIGHT TERMS</b>
                                    </h1>-->
                                    <li>
                                      Bizminer Vestimate® Value basis derived
                                      from projected company sales; peer group
                                      average earnings %; and industry valuation
                                      multiples. Median ranges reflect a range
                                      of market conditions and business
                                      performance at this revenue scale.
                                    </li>
                                    <li>
                                      You should not use Bizminer Vestimates® in
                                      place of a professional valuation or as
                                      the basis of any specific business-related
                                      or other financial transaction; nor to
                                      secure a business or personal loan.
                                    </li>
                                    <li>
                                      Owner Earnings (Cash Flow) Approach:
                                      <p>
                                        Revenue/Owner Earnings market valuation
                                        approach
                                      </p>
                                    </li>
                                    <li>
                                      Sales Approach:
                                      <p>
                                        Revenue/Annual Sales market value
                                        approach
                                      </p>
                                    </li>
                                    <li>
                                      Median and Quartiles: Median:
                                      <p>
                                        the point at which 50% of a sample is
                                        above and 50% of
                                      </p>
                                    </li>
                                    <li>the same below the value.</li>
                                    <li>
                                      Quartile 1 lies at the mid-point between
                                      the median and the lowest value; Quartile
                                      3
                                    </li>
                                    <li>between the median and the highest value</li>
                                  </ul>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                          <div class="md-layout-item md-medium-size-100 md-size-50">
                            <md-card class="md-card-profile">
                              <md-card-header>
                                <h4 class="title m-0">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                  >Market Analysis Insight Terms</div>
                                </h4>
                              </md-card-header>
                              <md-card-content>
                                <div class="extra_space">
                                  <ul>
                                    <li>
                                      Market Area:
                                      <p>
                                        The selected market parameters for this
                                        industry. Where there are at least five
                                        identified industry establishments,
                                        default market parameters are:
                                      </p>
                                    </li>
                                    <li>
                                      15 MILE RADIUS
                                      <p>44-45 Retail Trade</p>
                                      <p>72 Accommodation-Food Services</p>
                                      <p>811-812 Other Services</p>
                                    </li>
                                    <li>
                                      METRO
                                      <p>23 Construction</p>
                                      <p>42 Wholesale Trade</p>
                                      <p>48-49 Transportation-Warehousing</p>
                                      <p>51 Information</p>
                                      <p>52 Finance and Insurance</p>
                                      <p>53 Real Estate- Rental and Leasing</p>
                                      <p>
                                        54 Professional-Scientific-Technical
                                        Services
                                      </p>
                                      <p>
                                        56
                                        Administrative-Support-Waste-Remediation
                                      </p>
                                      <p>61 Educational Services</p>
                                      <p>62 Health Care-Social Assistance</p>
                                      <p>71 Arts-Entertainment- Recreation</p>
                                      <p>
                                        813
                                        Religious-Grantmaking-Civic-Professional
                                        and Similar Organizations
                                      </p>
                                    </li>
                                    <li>
                                      US-NATIONAL
                                      <p>11 Agriculture-Forestry-Fishing-Hunting</p>
                                      <p>
                                        21 Mining-Quarrying- Oil &amp; Gas
                                        Extraction
                                      </p>
                                      <p>22 Utilities</p>
                                      <p>31-32-33 Manufacturing</p>
                                      <p>
                                        55 Management- Companies &amp;
                                        Enterprises
                                      </p>
                                    </li>
                                    <li>
                                      Industry Map:
                                      <p>
                                        Displays the closest operations in the
                                        same industry as the selected firm
                                      </p>
                                    </li>
                                    <li>
                                      Competitors:
                                      <p>
                                        The number of same-industry operations
                                        within the market area.
                                      </p>
                                    </li>
                                    <li>
                                      Industry Market Sales Volume:
                                      <p>Aggregate industry market sales</p>
                                    </li>
                                    <li>
                                      Average Site Sales:
                                      <p>
                                        Average annual revenue of industry
                                        market operations in the market area.
                                      </p>
                                    </li>
                                    <li>
                                      Average Small Business Sales:
                                      <p>
                                        Average annual sales of single site
                                        firms with 25employees in the market
                                      </p>
                                    </li>
                                    <li>
                                      Firm Sales Rank:
                                      <p>
                                        Sales rank based on this location's
                                        estimated revenue among all sameindustry
                                        market operations
                                      </p>
                                    </li>
                                    <li>
                                      US and Market Sales per Household:
                                      <p>
                                        Sales per household using the US as a
                                        comparisonbasis for the local market or,
                                        if a national market, displaying that
                                        value.
                                      </p>
                                    </li>
                                    <li>
                                      Per Capita Income:
                                      <p>Average area income per person</p>
                                    </li>
                                    <li>
                                      Median Household Income:
                                      <p>
                                        Median (mid-point) area income per
                                        household
                                      </p>
                                    </li>
                                  </ul>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </div>
                </div>
              </template>
            </nav-tabs-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CRHeader from './CRHeader.vue';
import { NavTabsCard } from '@/components';

export default {
  components: {
    NavTabsCard,
    CRHeader,
  },
  props:['headerData'],
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    companyReportSummary() {
      return this.$store.getters['user/companyReport'];
    },
    companyReportReleaseDisplay() {
      return this.$store.getters.companyReportReleaseDisplay;
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
  },
};
</script>
<style lang="scss">
.finanical-insights-body {
  .header-box {
    display: flex;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  .md-collapse-content {
    padding: 0;
  }

  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .fi-profile-pdf-box {
    display: flex;
    justify-content: flex-end;
  }

  .profile-title {
    font-size: 24px;
    font-weight: 400;
  }
}

.comp-profile {
  display: flex;
  align-items: start;

  .md-layout {
    text-align: center;

    p {
      margin-left: 0 !important;
    }
  }

  .market-insights {
    p {
      color: #3b7ef1;
    }
  }
}
.table-box-margin {
  .md-layout-item {
    .md-card {
      margin: 15px 0 !important;
    }
  }
}
.company-terms {
  p {
    margin: 0 !important;
  }
}
</style>
